// extracted by mini-css-extract-plugin
export default {"menu":"TasksMenu_menu__kx0Ei","dark":"TasksMenu_dark__RrpmY"};